import React, {useState} from "react";
import "./TrainingTable.sass";
import {useSelector} from "react-redux";
import _ from "lodash";
import moment from "moment";
import {getNameByValue, solveTypes, themes} from "../../../common/themes";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import ButtonComponent from "../../common/buttons/ButtonComponent";

export default function TrainingTable() {
    const [selectedTask, setSelectedTask] = useState();

    const {mental} = useSelector(state => state.training.tasks);

    const renderEmptyField = () => (
        <div className="TrainingTable-empty-field">
            Вы ещё не выполнили ни одной тренировки
        </div>
    )

    const renderItem = (task) => {
        const {answerDate, theme, solveType, speed, myAnswer, answer} = task;
        const className = myAnswer === answer ? "TrainingTable-right-answer" : "TrainingTable-wrong-answer";
        return (
            <div key={`TrainingTable-item-${task.id}`}
                 onClick={() => setSelectedTask(task)}
                 className="TrainingTable-row">
                <div className="TrainingTable-item">{moment(answerDate, "YYYY-MM-DD").format("DD MMMM")}</div>
                <div className="TrainingTable-item">{getNameByValue(themes, theme)}</div>
                <div className="TrainingTable-item">{getNameByValue(solveTypes, solveType)}</div>
                <div className="TrainingTable-item">{speed} сек</div>
                <div className="TrainingTable-item">
                    <div className={className}>
                        {myAnswer}
                    </div>
                </div>
                <div className="TrainingTable-item">{answer}</div>
            </div>
        )
    }

    const renderExerciseDialog = () => {
        const {theme, myAnswer, answer, values} = selectedTask;
        return <Dialog
            style={{zIndex: 1400}}
            open={!!selectedTask}
            onClose={() => setSelectedTask(undefined)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Упражнение ${getNameByValue(themes, theme)}`}
            </DialogTitle>
            <DialogContent>
                <div className="TrainingTable-answer-wrapper">
                    <div className="TrainingTable-answer-grid">
                        <div className="TrainingTable-answer-grid-answer">
                            <div>Ваш ответ: {myAnswer}</div>
                            <div>Правильный ответ: {answer}</div>
                        </div>
                        {values.map((value, i) => <div key={`TrainingTable-answer-item-${i}`}
                                                       className="TrainingTable-answer-grid-item">
                                <div className="TrainingTable-answer-grid-item-number">{i + 1}</div>
                                <div className="TrainingTable-answer-grid-item-value">{value}</div>
                            </div>
                        )}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <ButtonComponent onClick={() => setSelectedTask(undefined)}>Назад</ButtonComponent>
            </DialogActions>
        </Dialog>
    }

    return (
        <div className="TrainingTable-wrapper">
            <div className="TrainingTable-grid">
                <div className="TrainingTable-row">
                    <div className="TrainingTable-header">Дата</div>
                    <div className="TrainingTable-header">Тема</div>
                    <div className="TrainingTable-header">Как решать</div>
                    <div className="TrainingTable-header">Скорость</div>
                    <div className="TrainingTable-header">Ваш ответ</div>
                    <div className="TrainingTable-header">Ответ</div>
                </div>

                {mental && !_.isEmpty(mental.content) ? mental.content.map(renderItem) : renderEmptyField()}

            </div>
            {selectedTask && renderExerciseDialog()}
        </div>
    )
}